export default __webpack_public_path__ + "static/media/mapaMT.5d454e17.jpeg";